export function existsFullScreenApi(elem: HTMLElement | null) {
	if (!elem) return false;

	return (
		'requestFullscreen' in document.documentElement ||
		'mozRequestFullScreen' in document.documentElement ||
		'webkitRequestFullscreen' in document.documentElement ||
		'msRequestFullscreen' in document.documentElement
	);
}

export function existsFullScreenElement() {
	const doc: unknown = document;
	return (
		(doc as { fullscreenElement: Element | null }).fullscreenElement ||
		(doc as { mozFullScreenElement: Element | null }).mozFullScreenElement ||
		(doc as { webkitFullscreenElement: Element | null }).webkitFullscreenElement ||
		(doc as { msFullscreenElement: Element | null }).msFullscreenElement
	);
}

export async function requestFullScreen(elem: HTMLElement | null): Promise<void> {
	if (!elem) return;

	if ('requestFullscreen' in elem) return elem.requestFullscreen();
	if ('mozRequestFullScreen' in elem)
		return (elem as { mozRequestFullScreen: () => Promise<void> }).mozRequestFullScreen();
	if ('webkitRequestFullscreen' in elem)
		return (elem as { webkitRequestFullscreen: () => Promise<void> }).webkitRequestFullscreen();
	if ('msRequestFullscreen' in elem)
		return (elem as { msRequestFullscreen: () => Promise<void> }).msRequestFullscreen();
}

export async function exitFullScreenElement(): Promise<void> {
	if ('exitFullscreen' in document) return document.exitFullscreen();
	if ('mozCancelFullScreen' in document)
		return (document as { mozCancelFullScreen: () => Promise<void> }).mozCancelFullScreen();
	if ('webkitExitFullscreen' in document)
		return (document as { webkitExitFullscreen: () => Promise<void> }).webkitExitFullscreen();
	if ('msExitFullscreen' in document)
		return (document as { msExitFullscreen: () => Promise<void> }).msExitFullscreen();
}
